module.exports = __webpack_public_path__ + "static/media/bg.3d64f82a.png";